<div ng-if="editor.isDesigning()" ng-show="isDragged" class="shadow"></div>
<c-form-element-actions ng-if="editor.isDesigning()" editor="editor" element="field"></c-form-element-actions>
<label ng-if="tool || editable" ng-class="{selectable:editor.isDesigning()}" ng-mousedown="editor.dragBegin(field, $event)" title="{{(editor.isDesigning() ? 'move' : '')|translate}}" ng-bind-html="labelText"></label>
<span ng-if="!tool && editable" class="field-description" ng-bind-html="descriptionText"></span>
<div ng-if="!tool && editable">
    <div ng-if="!fieldValue.FieldOptions.length" style="font-style: italic;padding: 5px 0">{{'field.list.empty'|translate}}</div>
    <div ng-repeat="option in fieldValue.FieldOptions | filter: {Active: true} | orderBy: 'Position' track by option.Id">
        {{option.Text|localize:language}}
    </div>
    <button type="button" ng-click="editList()">{{'edit'|translate}}</button>
</div>
<div ng-if="tool">
    ...<br/>
    ...<br />
    ...
</div>